import { render, staticRenderFns } from "./UserBondDetail.vue?vue&type=template&id=2f6b7133&scoped=true"
import script from "./UserBondDetail.vue?vue&type=script&lang=js"
export * from "./UserBondDetail.vue?vue&type=script&lang=js"
import style0 from "./UserBondDetail.vue?vue&type=style&index=0&id=2f6b7133&prod&lang=css"
import style1 from "./UserBondDetail.vue?vue&type=style&index=1&id=2f6b7133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b7133",
  null
  
)

export default component.exports